import Api from '../api/api.js';

import Toaster from '../alerts/toaster.js';


export default class SortManager
{

	constructor(url)
	{
		this.url = url;
	}


	init()
	{
		this.cacheDom();

		this.bindEvents();
	}


	cacheDom() 
	{
		this.$sortable = $("#sortable1:not(.btn)");
	}


	bindEvents() 
	{
		this.$sortable.sortable({stop:this.onStopSorting.bind(this)});	

		this.$sortable.disableSelection();
	}


	getIds()
	{
		return $('#sortable1').find('li.grabbable')
			.filter(function() {
				return $(this).data('id');
			})
			.map(function(index, item) {
				return $(this).data('id');
			})
			.get();
	}


 	onStopSorting(e) 
 	{
		this.sort().then((response) => {

			this.sorted(response.msg);

		});

	}

	sort()
	{
		var ids = this.getIds();

		var data = {ids};

		return (new Api).postRequest(this.url, data);
	}


	sorted(msg = 'Sorted successfully')
	{
		(new Toaster).toast('Success', msg, 'success');
	}

}